import StringUtils from "./StringUtils";

class ScoreUtils {
    static score(questions, answers, userAnswers) {
        const scores = [];

        for (let i = 0; i < questions.length; i++) {
            const correctAnswers = answers;

            if (questions[i]['type'] !== "gap" && !correctAnswers[i]) {
                scores[i] = 0;
            } else if (questions[i]['type'] === "closed") {
                const isMultipleChoice = questions[i].multipleChoice;
                let score = 0;
                if (isMultipleChoice) {
                    if (!userAnswers[i] || userAnswers[i] === "") {
                        score = 0;
                    } else {
                        score = userAnswers[i].reduce((sum, answer) => {
                                const correct = correctAnswers[i].includes(answer);

                                if (correct) return sum += 1;
                                else return sum;
                            }, 0
                        );
                    }
                } else {
                    if (!userAnswers[i] || userAnswers[i] === "") {
                        score = 0;
                    } else {
                        const correct = correctAnswers[i].includes(userAnswers[i]);
                        if (correct) score = 1;
                        else score = 0;
                    }
                }
                scores[i] = score;
            } else if (questions[i]['type'] === "gap") {
                let score = 0;
                let gapIndex = 0;

                questions[i].subtasks.forEach((subtask, taskIndex) => {
                    let correct = true;

                    subtask
                        .split(" ")
                        .forEach((item, index) => {
                            if (item === "{%s}") {
                                const gap = gapIndex;
                                gapIndex += 1;
                                let gapCorrect = false;
                                const userAnswerElement = userAnswers[i][gap];
                                if (!userAnswerElement || userAnswerElement === "") {
                                    correct = false;
                                } else {
                                    const safeAnswer = StringUtils.toSafeString(userAnswerElement);
                                    const correctAnswer = correctAnswers[i] ? (correctAnswers[i][gap] || []) : [];
                                    for (const answer of correctAnswer) {
                                        if (safeAnswer === StringUtils.toSafeString(answer)) gapCorrect = true;
                                    }
                                    correct = correct && gapCorrect;
                                }
                            }
                        });

                    if (correct) score += 1;
                });

                scores[i] = score;
            } else {
                console.log("other?", i);
                scores[i] = 0;
            }
        }

        return scores;
    }
}

export default ScoreUtils;